import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import CustomMultiSelect from '../../../../components/CustomMultiSelect';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import Filters from '../../../../components/Filters';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetIdleReportListPagingAndFilterRequest } from '../../../../models/request/report/GetIdleReportListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import moment from 'moment';
import { DeviceService } from '../../../../services/DeviceService';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetIdleReportListPagingAndFilterRequest
    getData: (_filter?: GetIdleReportListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetIdleReportListPagingAndFilterRequest>>
}

const IdleReportListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={0}
                allowSelected={false}
                onExport={excelExport}
            />

            <Filters
                filter={filter}
                getData={getData}
                onReset={() => getData({ ...filter, selectedDevices: [], startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD'), currentPage: 1, skip: 0 })}
            >
                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Plaka</label>

                    <CustomMultiSelect
                        selectedValues={filter.selectedDevices}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                selectedDevices: e
                            })
                        }}
                        onMenuOpen={() => DeviceService.getDeviceList()}
                        labelName='vehicleName'
                        valueName='deviceId'
                    />
                </div>

                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Başlangıç Tarihi</label>
                    <input
                        type='date'
                        value={filter.startDate}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                startDate: e.target.value
                            })
                        }}
                        className='form-control form-control-solid'
                    />
                </div>

                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Bitiş Tarihi</label>
                    <input
                        type='date'
                        value={filter.endDate}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                endDate: e.target.value
                            })
                        }}
                        className='form-control form-control-solid'
                    />
                </div>
            </Filters>
        </React.Fragment>
    )
}

export default IdleReportListFilters;